import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import './AssetForm.css';

const AssetForm = () => {
  const inputClass = 'form-control form-control-sm';
   
  const [form, setForm] = useState({
    assetCode: '',
    assetName: '',
    COAcategory: '',
    category: '',
    subCategory: '',
    brand: '',
    ModelNo: '',
    SerialNo: '',
    purchaseDate: '',
    depreciationRate: '',
    location: '', // Maps to 'office'
    employee: '',
    supplier: '',
    room: '', // Maps to 'room_no'
    warranty: '',
    warrantyDuration: '',
    bookValue: '',
    allocationDate: '',
    stockRegisterId: '',
    depreciationStartDate: '',
    assetStatus: '',
    assetCondition: '',
    city: '',
    building: '',
    floor: '',
    isInsured: 'No',
  insurancePolicyNo: '',
  insuranceProvider: '',
  });

 const [assetCode, setAssetCode] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [location, setLocations] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [COAcategories, setCOAcategories] = useState([]);
  const [status, setStatus] = useState([]);
  const [condition, setCondition] = useState([]);
  const [city, setCity] = useState([]);
  const [floor, setFloor] = useState([]);
  const [building, setBuilding] = useState([]);
  const [error, setError] = useState('');


  // Set axios base URL
  axios.defaults.baseURL = 'https://testone.onebox.pk';

  // Axios headers
  const headers = {
    'Content-Type': 'application/json',
    // 'Authorization': 'Bearer your_token_here', // Uncomment if needed
  };

  useEffect(() => {
    const fetchAssetCode = async () => {
      try {
        const response = await axios.get('/api/assets/generate-id');
        console.log("Fetched asset code:", response.data); // ✅ Check what is returned
        setAssetCode(response.data.asset_Id); // Make sure this matches key in JSON
      } catch (error) {
        console.error("Error fetching asset code:", error);
      }
    };

    fetchAssetCode();
  }, []);


  // Fetch initial dropdown data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoints = [
        '/api/assets/asset_categories',
        '/api/assets/asset_subcategories',
        '/api/assets/COAcategories',
        '/api/assets/city',
        '/api/assets/floor',
        '/api/assets/rooms',
        '/api/assets/location',
        '/api/assets/employees',
        '/api/assets/suppliers',
        '/api/assets/asset_status',
        '/api/assets/asset_condition',
        '/api/assets/building',
        ];
        const responses = await Promise.all(
          endpoints.map(endpoint =>
            axios.get(endpoint, { headers }).catch(err => {
              console.error(`Error fetching ${endpoint}:`, err.response || err);
              return { data: [] };
            })
          )
        );
        console.log('API Responses:', responses.map(res => res.data));
        setCategories(responses[0].data);
        setSubcategories(responses[1].data);
        setCOAcategories(responses[2].data);
        setCity(responses[3].data);
        setFloor(responses[4].data);
        setRooms(responses[5].data);
        setLocations(responses[6].data);
        setEmployees(responses[7].data);
        setSuppliers(responses[8].data);
        setStatus(responses[9].data);
        setCondition(responses[10].data);
        setBuilding(responses[11].data);
        
      } catch (err) {
        console.error('Fetch Error:', err.response || err);
        setError('Failed to fetch dropdown data.');
      }
    };
    fetchData();
  }, []);

  // Fetch subcategories based on category
  
// Helper: safely lowercase a string
const safeLower = str => typeof str === 'string' ? str.trim().toLowerCase() : '';

// 1. Filter Subcategories by Category
const filteredSubcategories = subcategories.filter(s => {
  const matchedCategory = categories.find(
    c => safeLower(c.category) === safeLower(form.category)
  );
  return s.categoryId === matchedCategory?.id;
});

// 2. Filter Suppliers by Category
const filteredSuppliers = suppliers.filter(s => {
  const matchedCategory = categories.find(
    c => safeLower(c.category) === safeLower(form.category)
  );
  return s.categoryId === matchedCategory?.id;
});

// 3. Filter Building by City
const filteredBuilding = building.filter(b => {
  const matchedCity = city.find(
    c => safeLower(c.city) === safeLower(form.city)
  );
  return b.cityId === matchedCity?.id;
});

// 4. Filter Floor by Building
const filteredFloor = floor.filter(f => {
  const matchedBuilding = building.find(
    b => safeLower(b.building) === safeLower(form.building)
  );
  return f.buildingId === matchedBuilding?.id;
});

// Step 5: Filter Rooms by selected Floor
const matchedFloor = floor.find(f =>
  String(f.floor_no).trim() === String(form.floor).trim()
);

const filteredRooms = matchedFloor
  ? rooms.filter(r => {
      console.log(`Room check -> room.floorId: ${r.floorId}, matchedFloor.id: ${matchedFloor.id}`);
      return String(r.floorId) === String(matchedFloor.id);
    })
  : [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'category') {
      setForm(prev => ({
        ...prev,
        category: value,
        subCategory: '',
        supplier: '',
      }));
    } else if (name === 'floor') {
      setForm(prev => ({
        ...prev,
        floor: value,
        room: '',
      }));
    } else if (name === 'section') {
      setForm(prev => ({
        ...prev,
        section: value,
        room: '',
      }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
    if (name === 'isInsured' && value === 'No') {
  setForm(prev => ({
    ...prev,
    isInsured: 'No',
    insurancePolicyNo: '',
    insuranceProvider: ''
  }));
} else {
  setForm(prev => ({
    ...prev,
    [name]: value
  }));
}
  };

  const handleDateChange = (date, field) => {
  setForm(prev => ({
    ...prev,
    [field]: date ? date.toISOString().split('T')[0] : '',
  }));
};
 const [files, setFiles] = useState({
  invoice: null,
  approval: null,
  stockRegister: null,
});

const handleFileChange = (e, fileType) => {
  setFiles(prev => ({
    ...prev,
    [fileType]: e.target.files[0],
  }));
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append('assetCode', assetCode);
      data.append('assetName', form.assetName);
      data.append('COAcategory', form.COAcategory);
      data.append('category', form.category);
      data.append('subCategory', form.subCategory);
      data.append('brand', form.brand);
      data.append('ModelNo', form.ModelNo);
      data.append('SerialNo', form.SerialNo);
      data.append('warranty', form.warranty); 
      data.append('warrantyDuration', form.warrantyDuration);
      data.append('bookValue', form.bookValue);
      data.append('purchaseDate', form.purchaseDate);
      data.append('allocationDate', form.allocationDate);
      data.append('stockRegisterId', form.stockRegisterId);
      data.append('depreciationRate', form.depreciationRate || '');
      data.append('depreciationStartDate', form.depreciationStartDate);
      data.append('assetStatus', form.assetStatus);
      data.append('assetCondition', form.assetCondition);
      data.append('location', form.location); // Maps to 'office'
      data.append('city', form.city);
      data.append('building', form.building);
      data.append('supplier', form.supplier);
      data.append('room', form.room); // Maps to 'room_no'
      data.append('floor', form.floor);
      data.append('isInsured', form.isInsured);
      data.append('insurancePolicyNo', form.insurancePolicyNo);
      data.append('insuranceProvider', form.insuranceProvider);
     if (files.invoice) data.append('invoice', files.invoice);
    if (files.approval) data.append('approval', files.approval);
    if (files.stockRegister) data.append('stockRegister', files.stockRegister);

      console.log('Sending Payload:', [...data.entries()]);

      const response = await axios.post('/api/assets', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log('Asset created:', response.data);
      alert('✅ Asset registered successfully!');
    } catch (err) {
      console.error('Submit Error:', err.response?.data || err);
      alert(`❌ Error submitting form: ${err.response?.data?.message || 'Unknown error'}`);
    }
  };

  return (
    <div className="asset-form-container">
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit} className="container mt-5 mb-5 p-4 bg-light shadow rounded" style={{ maxWidth: '750px' }}>
        <center><h4 className="text-center fw-bold text-primary mb-4 border-bottom pb-2">📋 Asset Registration Form</h4></center>

        {/* ASSET DETAILS SECTION */}
        <div className="card mb-4">
          <center><div className="card-header bg-primary text-white fw-semibold">Asset Details</div></center>
          <div className="card-body row g-4">
            <div className="form-group-inline">
               <label htmlFor="assetCode">Asset Code</label>
              <input type="number" className={inputClass} value={assetCode} readOnly placeholder="Auto-generated" />
            </div>
            <div className="form-group-inline">
               <label htmlFor="assetName">Asset Name</label>
              <input type="text" className={inputClass} name="assetName" value={form.assetName} onChange={handleChange} placeholder="Enter Asset Name" required />
            </div>
            <div className="form-group-inline">
               <label htmlFor="COAcategory">Asset COA Category</label>
              <select className="form-group-inline" name="COAcategory" value={form.COAcategory} onChange={handleChange} required>
                <option value="">-- Select COA Category --</option>
                {COAcategories.map(c => (
                  <option key={c.id} value={c.COAcategory}>{c.COAcategory}</option>
                ))}
              </select>
            </div>
            <div className="form-group-inline">
              <label htmlFor="category">Asset Category</label>
              <select className="form-group-inline" name="category" value={form.category} onChange={handleChange} required>
                <option value="">-- Select Category --</option>
                {categories.map(c => (
                  <option key={c.id} value={c.category}>{c.category}</option>
                ))}
              </select>
            </div>
            <div className="form-group-inline">
              <label htmlFor="subcategory">Asset Subategory</label>
              <select className="form-group-inline" name="subCategory" value={form.subCategory} onChange={handleChange} required>
                <option value="">-- Select Subcategory --</option>
                {filteredSubcategories.map(s => (
                  <option key={s.id} value={s.subCategory}>{s.subCategory}</option>
                ))}
              </select>
            </div>
             <div className="form-group-inline">
              <label htmlFor="brand">Asset Brand</label>
              <input type="text" className={inputClass} name="brand" value={form.brand} onChange={handleChange} placeholder="Enter Brand Name" />
            </div>
             <div className="form-group-inline">
              <label htmlFor="ModelNo">Asset Model</label>
              <input type="number" className={inputClass} name="ModelNo" value={form.ModelNo} onChange={handleChange} placeholder="Enter Model Number" />
            </div>
             <div className="form-group-inline">
              <label htmlFor="SerialNo">Asset Serial No</label>
              <input type="number" className={inputClass} name="SerialNo" value={form.SerialNo} onChange={handleChange} placeholder="Enter Serial Number" />
            </div>
           
          </div>
        </div>

        
        {/* SUPPLIER DETAILS SECTION */}
        <div className="card mb-4">
          <center><div className="card-header bg-primary text-white fw-semibold">Supplier Details</div></center>
          <div className="form-group-inline">
            <label htmlFor="supplier">Supplier Name</label>
            <select className="form-group-inline" name="supplier" value={form.supplier} onChange={handleChange} required>
              <option value="">-- Select Supplier --</option>
              {filteredSuppliers.map(s => (
                <option key={s.id} value={s.supplier_name}>{s.supplier_name}</option>
              ))}
            </select>
          </div>
          
           <div className="form-group-inline">
            <label htmlFor="warranty">Asset Warranty</label>
              <input type="text" className={inputClass} name="warranty" value={form.warranty} onChange={handleChange} placeholder="Yes/No" />
            </div>
            <div className="form-group-inline">
              <label htmlFor="warrantyDuration">Warranty Duration</label>
              <input type="number" className={inputClass} name="warrantyDuration" value={form.warrantyDuration} onChange={handleChange} placeholder="Enter Warranty Duration" />
            </div>
           <div className="form-group-inline">
            <label htmlFor="purchaseDate">Asset Purchase Date</label>
             <DatePicker
                selected={form.purchaseDate ? new Date(form.purchaseDate) : null}
                 onChange={date => handleDateChange(date, 'purchaseDate')}
                 className={inputClass}
                name="purchaseDate"
                placeholderText="Select purchase date"
                dateFormat="yyyy-MM-dd"
               required
                />
            </div>
            
            <div className="form-group-inline">
             <label htmlFor="invoiceFile" className="btn btn-outline-secondary w-100">
                  {files.invoice ? `📎 ${files.invoice.name}` : '📁 Invoice'}
                </label>
                <input
                  type="file"
                  id="invoiceFile"
                  onChange={e => handleFileChange(e, 'invoice')}
                  className="d-none"
                />
            </div>
            <div className="form-group-inline">
              <label htmlFor="bookValue">Asset Cost</label>
              <input type="number" className={inputClass} name="bookValue" value={form.bookValue} onChange={handleChange} placeholder="Enter Book Value" />
            </div>
        </div>

        {/* EMPLOYEE DETAILS  */}
         <div className="card mb-4">
        
          <center><div className="card-header bg-primary text-white fw-semibold">Asset Allocation Details</div></center>
          <div className="card-body row g-4">
             
            <div className="form-group-inline">
              <label htmlFor="employee"  >Employee Name</label>
              <select className="form-group-inline" name="employee" value={form.employee} onChange={handleChange} required>
                <option value="">-- Select Employee --</option>
                {employees.map(e => (
                  <option key={e.id} value={e.emp_name}>{e.emp_name}</option>
                ))}
              </select>
           
            </div>
             <div className="form-group-inline">
              <label htmlFor="allocationDate">Asset Purchase Date</label>
              <DatePicker
                    selected={form.allocationDate ? new Date(form.allocationDate) : null}
                    onChange={date => handleDateChange(date, 'allocationDate')}
                    className={inputClass}
                    name="allocationDate"
                    placeholderText="Select allocation date"
                    dateFormat="yyyy-MM-dd"
                    required
              />
            </div>
            <div className="form-group-inline">
             <label htmlFor="approvalFile" className="btn btn-outline-secondary w-100">
                    {files.approval ? `📎 ${files.approval.name}` : '📁 Approval Documents'}
                  </label>
                  <input
                    type="file"
                    id="approvalFile"
                    onChange={e => handleFileChange(e, 'approval')}
                    className="d-none"
                  />
            </div>
            <div className="form-group-inline">
              <label htmlFor="stockRegisterId">Stock Id</label>
              <input type="number" className={inputClass} name="stockRegisterId" value={form.stockRegisterId} onChange={handleChange} placeholder="Enter Stock Register Id" />
            </div>
            
            <div className="form-group-inline">
             <label htmlFor="stockRegisterFile" className="btn btn-outline-secondary w-100">
                  {files.stockRegister ? `📎 ${files.stockRegister.name}` : '📁  Stock Register'}
                </label>
                <input
                  type="file"
                  id="stockRegisterFile"
                  onChange={e => handleFileChange(e, 'stockRegister')}
                  className="d-none"
                />
            </div>
            <div className="form-group-inline">
              <label htmlFor="depreciationRate">Depreciation Rate</label>
              <input type="number" className={inputClass} name="depreciationRate" value={form.depreciationRate} onChange={handleChange} placeholder="Enter Depreciation Rate (%)" />
            </div>
             <div className="form-group-inline">
              <label htmlFor="depreciationStartDate">Depreciation Date</label>
              <DatePicker
                  selected={form.depreciationStartDate ? new Date(form.depreciationStartDate) : null}
                  onChange={date => handleDateChange(date, 'depreciationStartDate')}
                  className={inputClass}
                  name="depreciationStartDate"
                  placeholderText="Select depreciation start date"
                  dateFormat="yyyy-MM-dd"
                  required
                />
            </div>
            <div className="form-group-inline">
              <label htmlFor="assetStatus">Asset Status</label>
              <select className="form-group-inline" name="assetStatus" value={form.assetStatus} onChange={handleChange} required>
                <option  value="">-- Select Asset Status --</option>
                {status.map(s => (
                  <option key={s.id} value={s.status}>{s.status}</option>
                ))}
              </select>
            </div>
            <div className="form-group-inline">
              <label htmlFor="assetCondition">Asset Condition</label>
              <select className="form-group-inline" name="assetCondition" value={form.assetCondition} onChange={handleChange} required>
                <option  value="">-- Select Asset Condition --</option>
                {condition.map(c => (
                  <option key={c.id} value={c.asset_condition}>{c.asset_condition}</option>
                ))}
              </select>
            </div>
           
          </div>
        </div>
        
       {/*location DETAILS  */}
        <div className="card mb-4">
          <center><div className="card-header bg-primary text-white fw-semibold">Asset Location Details</div></center>
          <div className="card-body row g-4">
              <div className="form-group-inline">
                <label htmlFor="location">Asset Location</label>
              <select className="form-group-inline" name="location" value={form.location} onChange={handleChange}>
                <option value="">-- Select Asset Location --</option>
                {location.map(l => (
                  <option key={l.id} value={l.location}>{l.location}</option>
                ))}
              </select>
            </div>
             <div className="form-group-inline">
              <label htmlFor="city">City</label>
              <select className="form-group-inline" name="city" value={form.city} onChange={handleChange}>
                <option value="">-- Select City --</option>
                {city.map(c => (
                  <option key={c.id} value={c.city}>{c.city}</option>
                ))}
              </select>
            </div>

            <div className="form-group-inline">
              <label htmlFor="building">Building No</label>
              <select className="form-group-inline" name="building" value={form.building} onChange={handleChange}>
                <option value="">-- Select Building--</option>
                {filteredBuilding.map(b => (
                  <option key={b.id} value={b.building}>{b.building}</option>
                ))}
              </select>
            </div>
            <div className="form-group-inline">
              <label htmlFor="floor">Floor No</label>
              <select className="form-group-inline" name="floor" value={form.floor} onChange={handleChange} required>
                <option value="">-- Select Floor No --</option>
                {filteredFloor.map(f => (
                  <option key={f.id} value={f.floor_no}>{f.floor_no}</option>
                ))}
              </select>
            </div>
             <div className="form-group-inline">
              <label htmlFor="room">Room No</label>
              <select className="form-group-inline" name="room" value={form.room} onChange={handleChange} required>
                <option value="">-- Select Room No --</option>
                {filteredRooms.map(r => (
                  <option key={r.id} value={r.room_no}>{r.room_no}</option>
                ))}
              </select>
            </div>
          </div>
          </div>
          {/* INSURANCE SECTION */}
<div className="card mb-4">
  <center><div className="card-header bg-primary text-white fw-semibold">Insurance Details</div></center>
  <div className="card-body row g-4">
    
    {/* Radio Buttons for Yes/No */}
    <div className="form-group-inline">
      <label className="me-3">Is the asset insured?</label>
      <div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="isInsured" value="Yes"
            checked={form.isInsured === "Yes"} onChange={handleChange} />
          <label className="form-check-label">Yes</label>
        </div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="isInsured" value="No"
            checked={form.isInsured === "No"} onChange={handleChange} />
          <label className="form-check-label">No</label>
        </div>
      </div>
    </div>

    {/* Conditionally Render Insurance Fields */}
    {form.isInsured === "Yes" && (
      <>
        <div className="form-group-inline">
          <label htmlFor="insurancePolicyNo">Insurance Policy No</label>
          <input
            type="text"
            className={inputClass}
            name="insurancePolicyNo"
            value={form.insurancePolicyNo}
            onChange={handleChange}
            placeholder="Enter Policy Number"
            required
          />
        </div>

        <div className="form-group-inline">
          <label htmlFor="insuranceProvider">Insurance Provider </label>
          <input
            type="text"
            className={inputClass}
            name="insuranceProvider"
            value={form.insuranceProvider}
            onChange={handleChange}
            placeholder="Enter Provider Name"
            required
          />
        </div>
      </>
    )}
  </div>
</div>

        {/* SUBMIT BUTTON */}
        <div className="text-end">
          <button type="submit" className="btn btn-success px-4">✅ Submit</button>
        </div>
      </form>
    </div>
  );
};

export default AssetForm;